import React from 'react';

import { getMeta, persisFilters } from '../../actions/filters';
import { FiltersSearchButtons } from '../../components/FiltersSearchButtons';
import { formatOfferCount } from './helpers';
import { useDispatch, useSelector } from 'react-redux';
import { selectMeta } from '../../selectors/filters/selectMeta';
import { selectGeocode } from '../../selectors/filters/selectGeocode';
import { selectGeoSearch } from '../../selectors/filters';
import { selectRegionId } from '../../selectors/filters/selectRegionId';
import { IApplicationState, TThunkDispatch } from '../../types/redux';

export const FiltersSearchButtonsContainer = () => {
  const meta = useSelector(selectMeta);
  const geocode = useSelector(selectGeocode);
  const geoSearch = useSelector(selectGeoSearch);
  const regionId = useSelector(selectRegionId);
  const mainTownId = useSelector((state: IApplicationState) => state.geoSwitcher.region?.mainTownId ?? null);

  const dispatch: TThunkDispatch = useDispatch();

  const offerCount = formatOfferCount({ offerCount: meta.count });

  return (
    <FiltersSearchButtons
      meta={meta}
      geocode={geocode}
      offerCount={offerCount}
      regionId={regionId}
      mainTownId={mainTownId}
      getMeta={() => dispatch(getMeta())}
      persistFilters={() => dispatch(persisFilters())}
      disableRegionExpansion={!!geoSearch}
    />
  );
};
